import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { smartDocParamResolver_MDMs, smartDocParamResolverLabelMap } from '@app/advisor-content-shared';
export class DropDown_ParamResolver_MDM extends ComponentSync {
    adapter = SimpleListAdapter([...smartDocParamResolver_MDMs], node => _jsx(_Fragment, { children: smartDocParamResolverLabelMap[node.item] }));
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        return state;
    }
    // ######################## Logic ########################
    onResolverSelected = async (resolver) => {
        const param = this.state.editable;
        return param.updateObj({ resolver: resolver });
    };
    // ######################## Render ########################
    render() {
        const selected = this.state.editable.item.resolver;
        return _jsx(TS_DropDown, { adapter: this.adapter, selected: selected, onSelected: this.onResolverSelected });
    }
}
//# sourceMappingURL=DropDown_ParamResolver_MDM.js.map